<template>
  <BaseModal
    :title="_T('@Monobank payparts modal title')"
    @on-close-modal="onClose"
  >
    <div class="monobank-payparts">
      <p class="monobank-payparts__description">
        {{ _T("@Monobank payparts modal description") }}
      </p>
      <MyForm
        class="monobank-payparts__form"
        :state="form"
        :schema="schema"
        @submit="onSubmit"
      >
        <MyInput
          v-model.trim="form.phone"
          v-maska="'+38(0##) ### ## ##'"
          name="phone"
          type="tel"
          caption="@Phone number"
          autocomplete="phone"
        />
        <ButtonPrimary
          type="submit"
          :aria-label="_T('@Pay fo')"
          button-width="328px"
          :disabled="isHandled"
        >
          {{ _T("@Pay for") }}
        </ButtonPrimary>
      </MyForm>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "~/modules/shared/modals/BaseModal.vue";
import {
  monobankPayPartsModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore";
import MyInput from "~/nuxt_modules/common/ui/components/form/MyInput.vue";
import MyForm from "~/nuxt_modules/common/ui/components/form/MyForm.vue";
import { vMaska } from "maska/vue";
import ButtonPrimary from "~/modules/shared/buttons/ButtonPrimary.vue";
import { useSingletonHandler } from "~/uses/useSingletonHandler";
import { useAPI } from "~/uses/useMyFetch";
import { z } from "zod";
import { formatPhone, phoneCheck } from "~/utils/phoneHelper";

const modalStore = useModalStore();
const { getExtra } = storeToRefs(modalStore);

const payment = getExtra.value(monobankPayPartsModal).payment;

const form = reactive({
  phone: payment.phone,
});

const schema = z.object({
  phone: z
    .string(_T("@Entry field required"))
    .refine(
      (phone) => phoneCheck(phone),
      _T("@You entered an incorrect phone number"),
    ),
});

const { handle: onSubmit, isHandled } = useSingletonHandler(async (data) => {
  await useAPI("/purchase/order/payment/driver/monobank/payParts", {
    method: "POST",
    body: {
      orderId: payment.orderId,
      phone: formatPhone(data.phone),
    },
  }).then(() => onClose());
});

const onClose = () => {
  modalStore.toggleModal(monobankPayPartsModal);
};
</script>

<style scoped lang="scss">
.monobank-payparts {
  @include flex-container(column, flex-start, center);
  gap: 16px;

  &__description {
    max-width: 340px;
    text-align: center;
  }

  &__form {
    width: 100%;

    @include flex-container(column, flex-start, center);
    gap: 16px;
  }
}
</style>
